export default {
  type: 'layoutColumns',
  shadow: '@theme:card.shadow',
  rounded: '@theme:card.rounded',
  fontName: '@theme:card.fontName',
  border: true,
  hover: 'light-7',
  padding: '2',
  fontSize: '3',
  fareBodyItem: {
    grow: '2',
    textColor: 'dark',
  },
  fareFooterItem: {
    justifyContent: 'end',
    alignItems: 'end',
    grow: '1',
    textColor: 'dark',
  },
  showOriginDestinationImage: false,
  showRoute: true,
  showDepartureInfo: true,
  showReturnInfo: true,
  showJourneyType: true,
  showTravelClass: false,
  showPrice: true,
  showCallToAction: true,
  fareItemOriginDestination: {
    showOriginAirportCode: false,
    showDestinationAirportCode: false,
    showSeparator: true,
    fontWeight: 'bold',
    fontSize: '4',
    textTransform: 'uppercase',
    style: { lineHeight: '1' },
  },
  fareItemRoute: {
    fontWeight: 'bold',
    fontSize: '4',
    textColor: 'black',
    marginBottom: '2',
    separatorLabel: {
      content: 'minus',
    },
  },
  fareItemJourneyType: {},
  fareItemTravelClass: {},
  fareItemDepartureReturn: {
    marginTop: 'auto',
  },
  fareItemDepartureInfo: {
    showDepartureText: false,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  fareItemReturnInfo: {
    showReturnText: false,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    fontWeight: 'bold',
    textAlign: 'right',
    pricePromoStyles: {},
    currencyStyles: {
      fontSize: '5',
      textColor: 'black',
    },
  },
  fareItemCallToAction: {
    shadow: '@theme:button.shadow',
    rounded: '@theme:button.rounded',
    textTransform: 'uppercase',
    fontSize: '4',
    fontWeight: 'bold',
    showCallToActionTextMin: true,
    paddingHeight: '1',
    paddingWidth: '4',
  },
};
